import { updateContactsById } from '../api';

const contactsArgs = (
  email,
  mobile,
  telephone,
  address,
  postalcode,
  facebook,
  linkedin,
  linkMaps,
) => ({
  email,
  mobile,
  telephone,
  address,
  postalcode,
  facebook,
  linkedin,
  linkMaps,
});

const updateContact = (
  id,
  email,
  mobile,
  telehone,
  address,
  postalcode,
  facebook,
  linkedin,
  linkMaps,
) => updateContactsById(
  id,
  contactsArgs(email, mobile, telehone, address, postalcode, facebook, linkedin, linkMaps),
);

export default updateContact;
